import React from "react";
import { api } from "../api";

export const useGenericAPI = baseURL => {
  const [loading, setLoading] = React.useState(false);
  const [data, setData] = React.useState(null);
  const [error, setError] = React.useState(null);

  const getRequest = React.useCallback(
    async url => {
      try {
        setLoading(true);
        const response = await api.get(baseURL + url);
        setLoading(false);
        setData(response.data);
      } catch (error) {
        setLoading(false);
        setError({ error: error.message });
      }
    },
    [baseURL],
  );

  const postRequest = React.useCallback(
    async (url, data = {}) => {
      try {
        setLoading(true);
        const response = await api.post(baseURL + url, data);
        setLoading(false);
        setData(response.data);
      } catch (error) {
        setLoading(false);
        setError({ error: error.message });
      }
    },
    [baseURL],
  );

  return {
    getRequest,
    postRequest,
    data,
    loading,
    error,
  };
};
